<template>
  <div :class="className">
    <div class="sticky-select">
      <q-select
        label="Select company"
        v-model="companyFilter"
        outlined
        :disable="companies.length === 0 || loading"
        label-color="grey-7"
        color="grey-7"
        :options="companies"
        :option-label="(company) => company.name"
        :option-value="(company) => company.id"
        dense
      >
        <template v-slot:no-option>
          <q-item>
            <q-item-section class="text-italic text-grey">
              There is no options.
            </q-item-section>
          </q-item>
        </template>
        <template v-slot:append>
          <q-icon
            size="15px"
            v-if="!!companyFilter.id"
            class="cursor-pointer"
            name="fas fa-times"
            @click="companyFilter = ''"
            @click.stop="!companyFilter.id"
          />
        </template>
      </q-select>
    </div>
    <div class="sticky-location">
      <q-select
        label="Select Location"
        v-model="multiFilter"
        outlined
        :display-value="shorter"
        multiple
        :disable="locations.length === 0 || loading || !companyFilter.id"
        label-color="grey-7"
        color="grey-7"
        :options="locations"
        dense
      >
        <template v-slot:append>
          <q-icon
            size="15px"
            style="margin-top: 3px"
            v-if="!!multiFilter.length > 0"
            class="cursor-pointer"
            name="fas fa-times"
            @click="multiFilter = []"
            @click.stop="!multiFilter.length === 0"
          />
        </template>
        <template v-slot:option="locations">
          <q-item
            @click="locationFilterPusher(locations.opt)"
            dense
            clickable
            v-ripple
          >
            <q-item-section side top>
              <q-checkbox
                size="xs"
                v-model="multiFilter"
                :val="locations.opt"
              />
            </q-item-section>
            <q-item-section>{{ locations.opt.code }}</q-item-section>
          </q-item>
        </template>
      </q-select>
    </div>
    <div class="sticky-location">
      <q-select
        label="Custom Tag Lists"
        v-model="tagQ"
        outlined
        :display-value="shorterTag"
        multiple
        :disable="
          tags.length === 0 || loading || $store.state.tag.tags.length === 0
        "
        label-color="grey-7"
        color="grey-7"
        :options="tags"
        dense
      >
        <template v-slot:append>
          <q-icon
            size="15px"
            style="margin-top: 3px"
            v-if="!!tagQ.length > 0"
            class="cursor-pointer"
            name="fas fa-times"
            @click="tagQ = []"
            @click.stop="!tagQ.length === 0"
          />
        </template>
        <template v-slot:option="tags">
          <q-item @click="tagFilterPusher(tags.opt)" dense clickable v-ripple>
            <q-item-section side top>
              <q-checkbox size="xs" v-model="tagQ" :val="tags.opt" />
            </q-item-section>
            <q-item-section>{{ tags.opt.name }}</q-item-section>
          </q-item>
        </template>
      </q-select>
    </div>
    <div class="sticky-location">
      <q-select
        label="Status"
        v-model="statusQ"
        outlined
        :display-value="shorterStatus"
        multiple
        label-color="grey-7"
        color="grey-7"
        :options="statuses()"
        dense
      >
        <template v-slot:append>
          <q-icon
            size="15px"
            style="margin-top: 3px"
            v-if="!!statusQ.length > 0"
            class="cursor-pointer"
            name="fas fa-times"
            @click="statusQ = []"
            @click.stop="!statusQ.length === 0"
          />
        </template>
        <template v-slot:option="status">
          <q-item @click="statusFilterPusher(status.opt)" dense clickable v-ripple>
            <q-item-section side top>
              <q-checkbox size="xs" v-model="statusQ" :val="status.opt" />
            </q-item-section>
            <q-item-section>{{ status.opt.label }}</q-item-section>
          </q-item>
        </template>
      </q-select>
    </div>
    <div class="flex-1"></div>
    <slot name="activator"></slot>
  </div>
</template>

<script>
import {defaultStatuses, statuses} from "@/enums";
export default {
  data() {
    return {
      localeSearch: this.$store.state.vehicleClassPerformance.search,
    };
  },
  props: {
    className: String,
  },
  methods: {
    statuses() {
      return statuses
    },
    searchVin() {
      this.search = this.localeSearch;
    },
    resetSearch() {
      this.localeSearch = "";
      this.search = "";
    },
    locationFilterPusher(location) {
      if (this.multiFilter.some((item) => item.id === location.id)) {
        const index = this.multiFilter
          .map((item) => item.id)
          .indexOf(location.id);
        if (index !== -1) {
          this.$store.commit("vehicleClassPerformance/REMOVE_MULTI_FILTER", index);
        }
      } else {
        this.multiFilter = [...this.multiFilter, location];
      }
    },
    tagFilterPusher(tag) {
      let deep = [...this.tagQ];
      const index = deep.findIndex(item => item.id === tag.id);
      index !== -1 ? deep.splice(index, 1) : (deep = [...deep, tag]);
      this.tagQ = deep;
    },
    statusFilterPusher(status) {
      let deep = [...this.statusQ];
      const index = deep.findIndex(item => item.value === status.value);
      index !== -1 ? deep.splice(index, 1) : (deep = [...deep, status]);
      this.statusQ = deep;
    },
  },
  computed: {
    tags: {
      get() {
        return this.$store.state.tag.tags;
      },
      set(val) {
        this.$store.commit("tag/SET_TAGS", val);
      },
    },
    tagQ: {
      get() {
        return this.$store.state.vehicleClassPerformance.tagQ;
      },
      set(val) {
        this.$store.commit("vehicleClassPerformance/SET_TAG_Q", val);
      },
    },
    statusQ: {
      get() {
        return this.$store.state.vehicleClassPerformance.statusQ;
      },
      set(val) {
        this.$store.commit("vehicleClassPerformance/SET_STATUS_Q", val);
      },
    },
    shorter() {
      if (this.multiFilter.length > 0 && this.multiFilter.length < 2) {
        return this.multiFilter[0].code;
      } else if (this.multiFilter.length > 1) {
        return `${this.multiFilter[0].code} +${this.multiFilter.length - 1}`;
      }
    },
    shorterTag() {
      if (this.tagQ.length > 0 && this.tagQ.length < 2) {
        return this.tagQ[0].name;
      } else if (this.tagQ.length > 1) {
        return `${this.tagQ[0].name} +${this.tagQ.length - 1}`;
      }
    },
    shorterStatus() {
      if (this.statusQ.length > 0 && this.statusQ.length < 2) {
        return this.statusQ[0].label;
      } else if (this.statusQ.length > 2) {
        return `${this.statusQ[0].label}, ${this.statusQ[1].label} +${this.statusQ.length - 2}`;
      }
    },
    multiFilter: {
      get() {
        return this.$store.state.vehicleClassPerformance.multiFilter;
      },
      set(val) {
        this.$store.commit("vehicleClassPerformance/SET_MULTI_FILTER", val);
      },
    },
    companyFilter: {
      get() {
        return this.$store.state.vehicleClassPerformance.companyFilter;
      },
      set(val) {
        this.$store.commit("vehicleClassPerformance/SET_COMPANY_FILTER", val);
      },
    },
    locationFilter: {
      get() {
        return this.$store.state.vehicleClassPerformance.locationFilter;
      },
      set(val) {
        this.$store.commit("vehicleClassPerformance/SET_LOCATION_FILTER", val);
      },
    },
    locations: {
      get() {
        return this.$store.state.vehicleClassPerformance.locations;
      },
      set(val) {
        this.$store.commit("vehicleClassPerformance/SET_LOCATIONS", val);
      },
    },
    companies: {
      get() {
        return this.$store.state.company.companies;
      },
      set(val) {
        this.$store.commit("company/SET_USER_COMPANIES", val);
      },
    },
    grid: {
      get() {
        return this.$store.state.vehicleClassPerformance.grid;
      },
      set(val) {
        this.$store.commit("vehicleClassPerformance/SET_GRID_TYPE", val);
      },
    },
    loading() {
      return this.$store.state.vehicleClassPerformance.loading;
    },
    search: {
      get() {
        return this.$store.state.vehicleClassPerformance.search;
      },
      set(val) {
        this.$store.commit("vehicleClassPerformance/SET_SEARCH", val);
      },
    },
  },
  mounted() {
    this.statusQ = defaultStatuses;
  },
  watch: {
    search(n, o) {
      this.localeSearch = n;
    },
  },
};
</script>
